<template>
  <div class="searchTop">
    <van-row type="flex" align="center" class="search-top-row">
      <van-col class="colItem">
        <van-search
          v-model="text"
          @input="handleInput"
          show-action
          shape="round"
          background="transparent"
          :placeholder="$t.checkWaybill.searchText"
        >
          <template #action>
            <div @click="changeType(1)">{{ $t.meta.search }}</div>
          </template>
        </van-search>
      </van-col>
      <van-col class="colItem fliterItem" @click="changeType(2)">
        <div :class="isFilter ? 'itemTopAction' : ''">{{ $t.meta.filter }}</div>
      </van-col>
    </van-row>
  </div>
</template>
<script>
import Vue from "vue";
import { Row, Col, Search } from "vant";
Vue.use(Row).use(Col).use(Search);

export default {
  name: "SearchTop",
  props: ["orderBy", "isFilter", "menuState"],
  data() {
    return {
      text: "",
    };
  },
  mounted() {
    this.$bus
      .$off("clearCheckWaybillSearch")
      .$on("clearCheckWaybillSearch", (isClear) => {
        if (isClear) this.text = "";
      });
  },
  methods: {
    handleInput() {
      this.$emit("handleInput", this.text);
    },
    changeType(orderBy) {
      this.$emit("changeOrderBy", {
        orderBy: orderBy,
        text: this.text,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/publicStyle.scss";
@import "~assets/scss/var";
.searchTop {
  width: 100%;
  background-color: #ffffff;
  .search-top-row {
    width: 100%;
    text-align: center;
    background-color: transparent;
    .fliterItem {
      width: 20% !important;
    }
    .colItem {
      width: 80%;
      text-align: center;
      font-size: 14px;
      color: #333333;
      .van-search__action {
        color: #333333;
      }
      .van-search__content {
        padding: 0px;
        margin-right: 10px;
        .van-cell {
          padding: 5px 8px 5px 8px;
        }
      }
      .itemTop {
        @include publicFlex;
        text-align: center;
        justify-content: center;
        -webkit-justify-content: center;
        .itemTopName {
          margin: 0;
          padding: 0;
        }
      }
      .itemTopAction {
        color: $-color-primary;
        font-weight: bold;
      }
    }
  }
}
</style>
